import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import PlatformName from '../../components/platformName/index.jsx';
import '../../assets/css/common.less';
import './index.less';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, isNotNull, getPlatformName, messageShow, matchSupplierProduct, systemConfig, getZkShopName, getTaoteShopName } from '../../utils/http';
import { MatchTaoteLinkRequest } from '../../utils/api';
import { Dialog, Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Steps, Progress,DatePicker } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import $ from 'jquery';
import ShowModal from '../../components/showModal/index.jsx';
import ChangeProductsModuleV2 from '../../components/changeProductsModuleV2/index.jsx';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import SkuMappingsModule from '../../components/skuMappingsModule/index.jsx';
import { commonRequest,LoadProductSkuMappingV2Request } from '../../utils/api';
import { huoyuanLink } from '../../utils/index.js';
import dayjs from 'dayjs';
import MyPopover from '../../components/popover/index.jsx';
import ChangeProductByAlibaba from '../../components/changeProductByAlibaba/index.jsx';
import { otherExposureReport } from '../../utils/alibabareport.js';

class ShopProduct extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alibabaPageKey:'offer_list',
            selectShopId: "",//当前登录的店铺id，非阿里的
            selectShopName: '',//列表显示的店铺名称
            selectplatformType: "WxVideo",//当前登录的店铺类型
            selectProductId: '',//编辑商品id
            productList: [],//商品列表
            ownerShopUidToken: '',
            productTitle: "",
            productStatus: 'published',
            PageIndex: "",
            pageSize: 10,
            current: 1,
            total: 0,
            isLoading: false,
            loadingTitle: "加载中...",
            isNoProductList: false,
            selectProduct: null,//选择的商品
            selectProductSkuId: '',//选择了哪个店铺商品的sku的下拉框。（选择1688商品sku框）
            supplierProduct: null,//供应商商品
            supplierProductSkuList: [],//供应商商品sku
            offerId: '',//供应商商品   如果是从代发页面跳转，这个是有值的  props.location.state.offerId跳过来链接参数
            isRelevanceModal: false,   //商品映射弹窗
            relevanceProductItem: null,//选中映射商品
            shopList: [],
            //灰度环境编码，灰度5环境的用户，显示新版一对多关联页面
            //2022-07-05，灰度5上正式，这里默认指向5. 等后续没问题了，old方法就隐藏
            environmentNumber: 5,
            fromShopProductManagerMenu: true,
            confrimChangeProduct: false,
            isShowChangeProduct: false,
            selectedShopProduct: null,
            changeStatus: 'first',
            isShowWarnText: false,
            relateSucessDailogShow: false,


            isShowWarn: false,

            //同步状态
            sysncStatusTaskProgress: 100,
            lastSyncTimeByShop: '',
            isSyncingProduct: false,

            //是否显示质量分
            isShowDiagnosis: false,

            //确认关联对话框
            relevanceDialogVisible: false,

            //供应商商品来源标记
            productTag: null,
            //根据商品id或商品标题查询
            searchType: 'ProductID',
            isChangeProductsModule: false,
            changeSearchNavsType: 0,   //0为关联货源  1找同款
            showRelationProduct: false,
            isTip: true, //同步商品提示
            isSync: true, //是否自动同步
            isSyncProductModal: false, //是否显示同步弹窗
            // 同步弹窗参数
            daterangepickerValue: '', 

            // 引导参数
            isShowGuide: false,//是否显示蒙层
            guideStep: 0,
            guideData: [
                {
                    img: 'https://www.dgjapp.com/public/images/fxdf-ph/step-1-20240319.png',
                },
                {
                    img: 'https://www.dgjapp.com/public/images/fxdf-ph/step-2-20240319.png',
                },
                {
                    img: 'https://www.dgjapp.com/public/images/fxdf-ph/step-3-20240320.png',
                }
            ],
            // 同步弹窗输入框限制状态
            syncConditionStatus: false,
        };
    }

    componentDidMount() {
        //传过来的参数
        var canshu = this.props.location.state;
        var offerId = null;

        if (canshu != null && canshu != undefined) {
            offerId = canshu.offerId;
            var productTag = canshu.productTag;
            if (productTag)
                this.setState({ productTag: productTag });

            if (offerId != "" && offerId != null && offerId != undefined) {
                this.setState({ offerId: offerId, fromShopProductManagerMenu: false });
            }
        }

        var zhukeToken = getToken();
        var that = this;
        if (zhukeToken != "")
        {
            that.loadData(offerId);
            otherExposureReport(that.state.alibabaPageKey);
        }
        else {

            setTimeout(() => {
                var zhukeTokenTwo = getToken();
                if (zhukeTokenTwo == "") {
                    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
                    //var hasZhukeLoginShopTokens = "";//测试。
                    if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
                        loadZhuKeToken(hasZhukeLoginShopTokens);

                        setTimeout(() => {
                            var zhukeTokenThree = getToken();
                            if (zhukeTokenThree != "")
                                that.loadData(offerId);
                            else
                                that.setState({ isShowWarn: true });

                        }, 500);
                    } else
                        that.setState({ isShowWarn: true });
                } else
                    that.loadData(offerId);
            }, 500);

        }
    }

    loadSupplierProduct(offerId) {
        var offerIdList = [];
        if (typeof (offerId) == 'object') {
            offerId = offerId.ProductId
        }
        offerIdList.push(offerId);
        var that = this;
        requests({
            url: "/BatchDistribution/SupplerProductListByOfferId",
            data: { OfferIdList: offerIdList },
            success: (res) => {
                if (res.Success) {
                    var list = res.Data.SupplerProductList;
                    var supplierProduct = null;
                    var supplierProductSkuList = [];
                    if (list.length > 0) {
                        supplierProduct = list[0];
                        var skuList = supplierProduct.Skus;
                        for (let i = 0; i < skuList.length; i++) {
                            supplierProductSkuList.push({
                                label: skuList[i].Color + skuList[i].Size,
                                value: skuList[i].SkuId
                            });
                        }
                    }

                    that.setState({ supplierProduct: supplierProduct, supplierProductSkuList: supplierProductSkuList });

                } else {

                }
            },
            fail: function (error) {

            }
        });
    }

    loadData = (offerId) => {
        var shopInfo = getLoginShopInfo();
        var that = this;
        if (offerId) {
            this.loadSupplierProduct(offerId);
        }
        this.setState({
            selectShopId: shopInfo.loginShopId,
            selectShopName: shopInfo.loginShopName,
            selectplatformType: shopInfo.loginShopPlatformType,

        }, () => {
            that.queryButton();
        })

        this.syncProductClick();
        this.loadProrUserByProductMask();
    }


    changeNav = (name) => {
        this.props.history.replace(name)
    }

    changeCurrent = (current) => {
        this.setState({
            current,
            checkAll: false
        }, () => {
            this.queryButton();
        })
    }
    changePageSize = (size) => {
        this.setState({
            pageSize: size,
            current: 1,
        }, () => {
            this.queryButton();
        })
    }




    queryButton = (isQuery) => {

        // var shopname = '';
        // var shopList = this.state.shopList;
        // for (var i = 0; i < shopList.length; i++) {
        //     if (shopList[i].Id == shopid) {
        //         shopid = shopList[i].Id;
        //         shopname = shopList[i].ShopName;
        //     }
        // }
        if (isQuery) {  //为true 时为搜索调用  current恢复第1页
            this.setState({ current: 1 }, () => {
                this.loadProductList();
            })
        } else {     //为切换页码时调用
            this.loadProductList();
        }

    }

    //获取商品列表(店铺)
    loadProductList() {
        if (this.state.isShowWarn) {
            Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
            return;
        }

        var data = {
            ShopId: this.state.selectShopId,
            ShopPt: this.state.selectplatformType,
            //ProductTitle: $("#productTitle").val(),
            ProductStatus: $("#productStatusId").val(),
            SaleState: $("#productSaleId").val(),//是否代销商品
            PageIndex: this.state.current,
            PageSize: this.state.pageSize,
            IsSync: "0",//进页面的时候，有触发一次同步，就不需要点击同步的时候，触发同步
        }

        var that = this;
        that.setState({ isLoading: true });

        var keyword = $("#productTitle").val();
        var searchType = this.state.searchType;
        if (searchType == "ProductID")
            data.ProductIds = keyword;
        else if (searchType == "ProductSubject")
            data.ProductTitle = keyword;

        var that = this;
        that.setState({ isLoading: true, loadingTitle: '加载商品中...' });
        requests({
            url: "/Product/List",
            data: data,
            success: (res) => {
                that.setState({ isLoading: false });
                // this.setState({linshiRes: JSON.stringify(res) });
                if (res.Success) {
                    var listData = res.Data.ProductList;
                    var total = res.Data.TotalCount;
                    var isNoProductList = total > 0 ? false : true;

                    if (listData == null || listData == undefined)
                        listData = [];


                    for (let i = 0; i < listData.length; i++) {
                        listData[i].isLoadItemDiagnosis = true;//加载中
                        listData[i].SuggestList = [];

                        listData[i].DiagnosisValue = 0; //质量分
                        listData[i].circleProValue = "";//质量分转半圆百分比 this.initCirclePro(0)
                        listData[i].SuggestionCount = 0;//待优化有多少个
                        listData[i].ItemDiagnosisList = [];//待优化详情列表
                    }

                    that.setState({ total, isNoProductList, productList: listData }
                        , () => {
                            that.loadKuaishouItemDiagnosis();
                        });

                    setTimeout(() => {
                        that.loadKuaishouItemDiagnosis();
                    }, 2000);
                } else {

                    Message({
                        message: "【请重新下拉获取】获取商品列表失败:" + res.Message,
                        type: 'warning'
                    });
                }

            },
            fail: (err) => { }
        });
    }

    loadProrUserByProductMask=()=>{
        var that=this;
        commonRequest.GetAndSaveCommonSet({ 
            Types:'Get',
            Keys:'zhukePuHuo/UserByProduct/mask',
            ShopId:this.state.selectShopId
         }).then((res) => {
            if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
            {
                return false;
            }
            if (res.Success) {
                var dates = res.Data;
                if(isNotNull(dates))
                {
                    if(dates.Values != "1")
                        that.setState({isShowGuide:true});
                }
                
          
            } 
        });


    }

    setProrUserByProductMask=()=>{
        commonRequest.GetAndSaveCommonSet({ 
            Types:'Set',
            Keys:'zhukePuHuo/UserByProduct/mask',
            ShopId:this.state.selectShopId,
            Values:'1'
         }).then((res) => {
            if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
            {
                return false;
            }
        });
    }


    //获取快手的质量分
    loadKuaishouItemDiagnosis = () => {

        if (this.state.isShowDiagnosis == false)
            return;

        var productList = this.state.productList;
        var idList = [];
        for (let i = 0; i < productList.length; i++) {
            idList.push(productList[i].PlatformId);
        }
        var data = {
            TargetShopId: $("#selectShop").val(),
            ProductIdList: idList
        };

        var that = this;
        requests({
            url: "/ProductQuality/ProductItemDiagnosisByKuaiShou",
            data: data,
            success: (res) => {
                if (res.Success) {
                    var listData = res.Data.DiagnosisList;

                    if (listData == null || listData == undefined)
                        listData = [];

                    var productList = that.state.productList;

                    for (let i = 0; i < productList.length; i++) {
                        productList[i].isLoadItemDiagnosis = false;//加载完毕
                        for (let j = 0; j < listData.length; j++) {
                            if (productList[i].PlatformId == listData[j].ProductId) {
                                productList[i].DiagnosisValue = listData[j].DiagnosisValue; //质量分
                                productList[i].circleProValue = this.initCirclePro(productList[i].DiagnosisValue);//质量分转半圆百分比
                                productList[i].SuggestionCount = listData[j].SuggestionCount;//待优化有多少个
                                productList[i].ItemDiagnosisList = listData[j].DignosisDetailList;

                                var itemDiagnosisList = listData[j].DignosisDetailList;//待优化详情列表,只有（Title、Content）
                                if (itemDiagnosisList == null || itemDiagnosisList == undefined)
                                    itemDiagnosisList = [];

                                var suggestList = [];
                                for (let k = 0; k < itemDiagnosisList.length; k++) {
                                    if (isNotNull(itemDiagnosisList[k].Content) && itemDiagnosisList[k].Content.indexOf('建议') != -1) {
                                        suggestList.push(itemDiagnosisList[k].Content.substring(itemDiagnosisList[k].Content.indexOf('建议'), itemDiagnosisList[k].Content.length));

                                        //详情中，不显示建议
                                        itemDiagnosisList[k].Content = itemDiagnosisList[k].Content.substring(0, itemDiagnosisList[k].Content.indexOf('建议'));
                                    }
                                }
                                productList[i].ItemDiagnosisList = itemDiagnosisList;
                                productList[i].SuggestList = suggestList;//建议



                                break;
                            }
                        }
                    }

                    // listData[i].isLoadItemDiagnosis = true;//加载中
                    // listData[i].SuggestList = [];

                    that.setState({ productList: productList });
                } else {
                    //app.MessageShow("【请重新下拉获取】获取商品列表失败:" + res.Message, 3500);
                }

            }
        });




        // for (let i = 0; i < productList.length; i++) {



        //     var itemDiagnosisList = [];
        //     itemDiagnosisList.push({
        //         Title: "这是标题",
        //         Content: "这是内容"
        //     })

        //     productList[i].DiagnosisValue = 92; //质量分
        //     productList[i].circleProValue=this.initCirclePro(productList[i].DiagnosisValue);//质量分转半圆百分比
        //     productList[i].SuggestionCount = 6;//待优化有多少个
        //     productList[i].ItemDiagnosisList = itemDiagnosisList;//待优化详情列表

        //     var suggestList = [];
        //     suggestList.push("建议优化标题1");
        //     suggestList.push("建议优化题目2");
        //     productList[i].SuggestList = suggestList;//建议
        // }


    }


    replateSupplierProduct = (item) => {
        const supplierProductId = item.SupplierProductId;
        this.state.selectedShopProduct = item;
        this.setState({ supplierProduct: null, supplierProductSkuList: null });
        if (!supplierProductId) {
            this.setState({ confrimChangeProduct: false, isShowChangeProduct: true });
        }
        else {
            this.setState({ confrimChangeProduct: true, isShowChangeProduct: false });
        }
    }

    replateSupplierProduct02 = () => {
        const item = this.state.selectedShopProduct
        const supplierProductId = item.SupplierProductId;
        this.setState({ changeSupplierProduct: { ProductId: item.SupplierProductId, SourcePlatform: item.SourcePlatform }, supplierProduct: null, supplierProductSkuList: null, selectedShopProduct: item, selectProductId: item.PlatformId });
        // if (!supplierProductId) {
        this.setState({ confrimChangeProduct: false, isChangeProductsModule: true });
        // }
        // else {
        //     this.setState({ confrimChangeProduct: true, isChangeProductsModule: false });
        // }

    }
    addSupplierProduct = (item, changeSearchNavsType) => {
        const supplierProductId = item.SupplierProductId;
        this.setState({ changeSupplierProduct: null, supplierProduct: null, supplierProductSkuList: null, changeSearchNavsType, selectedShopProduct: item, selectProductId: item.PlatformId });
        this.setState({ confrimChangeProduct: false, isChangeProductsModule: true });
    }
     //1688低价找货源弹窗
     changeProductConfirmByAlibaba = (item) => {
        console.log('changeProductConfirmByAlibaba->item =>',item)
        this.setState({
            isChangeProductsModuleByAlibaba: true,
            changeSupplierProduct: null, 
            supplierProduct: null, 
            supplierProductSkuList: null,
            selectedShopProduct: item,//选择的商品
            selectProductId: item.PlatformId, 
        });
    }

    //关闭确认更换货源弹窗
    closeConfrimChangeProduct = () => {
        this.setState({
            changeSupplierProduct: null,
            confrimChangeProduct: false
        });
    }

    //关闭确认更换货源弹窗
    closeChangeProduct = () => {
        this.setState({
            isShowChangeProduct: false,
            changeWidth: 650,
            changeStatus: "first",
            selectProduct: null,
            // supplierProduct:null,
            changeProduct: null,
            selectedShopProduct: null,
            changeSupplierProduct: null,
            // supplierProductSkuList:null
        });
    }



    relevanceProducFromChange = (item) => {
        var that = this;
        if (this.state.changeProduct == null) {
            messageShow("未获取到货源商品信息，请输入正确格式的货源链接", "warning");
            return;
        }

        this.setState({
            changeStatus: 'second',
            selectProduct: null,
            noticeText: '获取信息中...',
            changeWidth: 900,
        });

        var data = {
            ShopId: that.state.selectedShopProduct.ShopId,
            ProductId: that.state.selectedShopProduct.PlatformId
        };

        requests({
            url: "/Product/LoadProductAndSupplierProductSku",
            data: data,
            success: function (res) {
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                {
                    that.setState({ noticeText: '请求超时，请重试。' });
                    return;
                }

                that.setState({ noticeText: '' });

                if (res.Success) {
                    var product = res.Data.ProductFx;

                    var priceArr = [];
                    for (let i = 0; i < product.Skus.length; i++) {
                        priceArr.push(product.Skus[i].SalePrice);
                        product.Skus[i].SupplierSkuList = null;
                    }
                    priceArr.sort();
                    product.PriceArr = priceArr;

                    that.setState({
                        selectProduct: product,
                        selectPlatformTypeRelevance: that.state.selectedShopProduct.PlatformType
                    });
                } else {
                    messageShow("获取商品信息失败" + res.Message, "error");
                }
            },
        });
    }
    inputTextareaByChangeProduct = () => {
        var setTimes = this.state.setTimes;
        if (setTimes != null) {
            clearTimeout(setTimes);
            this.setState({
                setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
            })
        }
        else {
            this.setState({
                setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
            })
        }

    }
    //上一步
    previousChangeProduct = () => {
        this.setState({
            changeStatus: 'first',
            selectProduct: null,
            changeWidth: 650
        });
    }


    //确认关联，保存按钮
    sureRelevanceRequest = (isSomething) => {
        var selectProduct = this.state.selectProduct;
        var supplierProduct = this.state.supplierProduct;


        var skuMappingList = [];
        var skuList = selectProduct.Skus;

        for (let i = 0; i < skuList.length; i++) {
            if (skuList[i].SupplierSkuList == undefined || skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList[0].SupplierSkuId == "") {
                continue;
            }

            for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
                if (skuList[i].SupplierSkuList[n].SupplierSkuId == undefined || skuList[i].SupplierSkuList[n].SupplierSkuId == null ||
                    skuList[i].SupplierSkuList[n].SupplierSkuId == "" || skuList[i].SupplierSkuList[n].MappingCount <= 0) {
                    continue;
                }

                skuMappingList.push({
                    SkuId: skuList[i].SkuId,
                    SupplierSkuId: skuList[i].SupplierSkuList[n].SupplierSkuId,
                    MappingCount: skuList[i].SupplierSkuList[n].MappingCount
                });
            }
        }

        //判断
        if (skuMappingList.length <= 0) {
            messageShow("供应商规不能全部为空", "warning");
            return false;
        }

        var selectSupplierLoginId = this.state.selectSupplierLoginId;
        var selectSupplierProductId = this.state.selectSupplierProductId;
        var selectSourcePlatform = this.state.selectSourcePlatform;
        if (supplierProduct) {
            selectSupplierLoginId = supplierProduct.SupplierLoginId;
            selectSupplierProductId = supplierProduct.ProductId;
            selectSourcePlatform = supplierProduct.SourcePlatform;
        }
        var dataJson = {
            SupplierProductId: selectSupplierProductId,
            SupplierMemberId: '',
            SupplierLoginId: selectSupplierLoginId,
            ProductId: selectProduct.PlatformId,
            TargetShopId: this.state.selectShopId,
            SkuMappings: skuMappingList,
            TargetShopPt: this.state.selectplatformType,
            SourcePlatform: selectSourcePlatform,
        }

        if (this.state.productTag)
            dataJson.ProductTag = this.state.productTag;

        var that = this;
        that.setState({ isLoading: true, loadingTitle: '保存中...' });

        requests({
            url: "/BatchDistribution/RelateProduct",
            data: dataJson,
            success: (res) => {

                that.setState({ isLoading: false });
                if (res.Success) {

                    var productList = that.state.productList;
                    for (let i = 0; i < productList.length; i++) {
                        if (productList[i].PlatformId == selectProduct.PlatformId) {
                            productList[i].SupplierProductId = selectSupplierProductId;
                            break;
                        }
                    }
                    that.setState({ productList: productList, isShowChangeProduct: false, isRelevanceModal: false, isShowRelevanceProduct: false });//, relateSucessDailogShow: true 

                    messageShow("关联成功，可到代销商品中查看。", 'success');


                } else {
                    messageShow("关联货源失败:" + res.Message, "error");
                }


            },
            fail: function (error) {
                //console.log("aabb")
                that.setState({ isLoading: false });
            }
        });

    }


    //加载需要更换的货源
    loadProductSource = () => {
        this.setState({
            changeProduct: null,
            isShowChangeProduct: true,
            confrimChangeProduct: false,
            changeStatus: 'first',
            noticeText: "",
            isShowWarnText: false
        });
    }
    async loadSupplierProductByUrl(url) {
        var that = this;
        this.setState({
            changeProduct: null
        });

        if (url == null || url == '') {
            return;
        }

        // var regx = /detail.1688.com\/offer\/(.*?).html/g;
        // var rs = regx.exec(url);
        var data = {};

        // if (rs == undefined || rs == null || rs.length < 2 || rs[1] == '') {
        //     var numberRegx = /^[0-9]*$/g;
        //     rs = numberRegx.exec(url);
        //     if (rs == undefined || rs == null || rs.length < 1 || rs[1] == '') {
        //         that.setState({
        //             noticeText: '请输入正确格式的货源链接(例：https://detail.1688.com/offer/***.html或者商品ID)',
        //             isShowWarnText: true
        //         });
        //         return;
        //     } else {
        //         data.SupplierProductId = rs[0]
        //     }
        // } else {
        //     data.SupplierProductId = rs[1]
        // }

        const supplierProducts = matchSupplierProduct(url);
        if (supplierProducts.length == 0) {
            that.setState({
                noticeText: '请输入正确格式的货源链接(例：https://detail.1688.com/offer/***.html或淘口令)',
                isShowWarnText: true
            });
            return;
        }
        data.SupplierProductId = supplierProducts[0].supplierProductId
        data.SourcePlatform = supplierProducts[0].sourcePlatform

        that.setState({
            hasLoadBorder: true,
            noticeText: "正在抓取1688商品信息..",
            isShowLoadAction: true,
            isShowWarnText: false
        })

        if (supplierProducts[0].sourcePlatform == 'TaoteZhuKe' && !supplierProducts[0].supplierProductId) {
            const matchTaoteLinkRequestData = { Links: [supplierProducts[0].link] }
            const res = await MatchTaoteLinkRequest(matchTaoteLinkRequestData)
            if (res.Success) {
                if (res.Data.List && res.Data.List.length > 0) {
                    data.SupplierProductId = res.Data.List[0].Item2
                }
            }
            if (!data.SupplierProductId) {
                that.setState({
                    noticeText: '淘口令已失效',
                    isShowWarnText: true
                });
                return;
            }
        }
        requests({
            url: "/Product/LoadSupplierProduct",
            data: data,
            success: function (res) {
                that.setState({ isShowLoadAction: false });


                if (res.Success) {
                    var supplierProduct = res.Data.AlibabaProduct;

                    //遍历sku获取价格区间,供应商sku列表
                    var priceArr = [];
                    var supplierProductSkuList = [];
                    for (let i = 0; i < supplierProduct.Skus.length; i++) {
                        priceArr.push(supplierProduct.Skus[i].Price);
                        var attrArr = JSON.parse(supplierProduct.Skus[i].Attributes);
                        var color = '';
                        var size = '';

                        for (let n = 0; n < attrArr.length; n++) {
                            if (n == 0) {
                                color = attrArr[n].AttributeValue;
                            } else {
                                size = attrArr[n].AttributeValue;
                            }
                        }

                        supplierProductSkuList.push({
                            label: color + size,
                            value: supplierProduct.Skus[i].SkuId
                        });
                    }
                    priceArr.sort();

                    var changeProduct = {
                        ImageUrl: supplierProduct.Images[0],
                        Subject: supplierProduct.Subject,
                        PriceArr: priceArr,
                        SupplyStock: supplierProduct.SupplyStock,
                        Text: '',
                        Status: supplierProduct.Status,
                        SupplierLoginId: supplierProduct.SupplierLoginId
                    }

                    that.setState({
                        changeProduct: changeProduct,
                        supplierProduct: supplierProduct,
                        supplierProductSkuList: supplierProductSkuList,
                        selectSupplierLoginId: supplierProduct.SupplierLoginId,
                        selectSupplierProductId: supplierProduct.ProductId
                    }, () => {
                        $(".changeProductsWrap .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
                            if ($(item).val() != "") {
                                $(item).addClass("active")
                            }
                        })
                    });
                } else {
                    that.setState({
                        noticeText: '非1688一件代发商品或当前商品需要通过厂家审核，请重新输入',
                        isShowWarnText: true
                    });
                }
            },
        });
    }


    //下拉  选中事件
    selectSupplierProduct = (e, skuId, index) => {

        var tarEle = e.target;
        if (tarEle.value != "") {
            $(tarEle).addClass("active")
        } else {
            $(tarEle).removeClass("active")
        }
        var supplierSkuId = e.target.parentNode.childNodes[0].selectedOptions[0].value;
        var supplierSkuName = e.target.parentNode.childNodes[0].selectedOptions[0].text;
        var mappingCount = e.target.parentNode.childNodes[1].value;

        if (mappingCount != null && mappingCount != '') {
            if (!(/(^[1-9]\d*$)/.test(mappingCount))) {
                messageShow("数量必须填正整数的", "warning");
                return false;
            }
        }

        var selectProduct = this.state.selectProduct;
        var skuList = selectProduct.Skus;
        //商品
        for (let i = 0; i < skuList.length; i++) {
            if (skuId == skuList[i].SkuId) {
                if (skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList.length == 0) {
                    skuList[i].SupplierSkuList = [];
                    skuList[i].SupplierSkuList.push({
                        SupplierSkuId: supplierSkuId,
                        SupplierSkuName: supplierSkuName,
                        MappingCount: 1
                    });
                }
                else {
                    for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
                        if (skuList[i].SupplierSkuList[n].SupplierSkuId == supplierSkuId && n != index) {
                            messageShow("该供应商规格在组合中已存在！", "warning");
                            e.target.selectedIndex = 0;
                            skuList[i].SupplierSkuList.splice(index, 1);
                            return false;
                        }
                    }

                    skuList[i].SupplierSkuList[index].SupplierSkuId = supplierSkuId;
                    skuList[i].SupplierSkuList[index].SupplierSkuName = supplierSkuName;
                    skuList[i].SupplierSkuList[index].MappingCount = mappingCount;

                    if (supplierSkuId == undefined || supplierSkuId == null || supplierSkuId == '') {
                        messageShow("规格不能选择空，当前选择是无效的！", "warning");
                        return false;
                    }
                }
            }
        }
        selectProduct.Skus = skuList;

        this.setState({ selectProduct: selectProduct })
    }

    //规格型号 添加规格
    addSupplierProductSku = (e, skuId) => {
        var selectProduct = this.state.selectProduct;
        var skuList = selectProduct.Skus;
        //商品
        for (let i = 0; i < skuList.length; i++) {
            if (skuId == skuList[i].SkuId) {
                if (skuList[i].SupplierSkuList == null) {
                    skuList[i].SupplierSkuList = [];
                    skuList[i].SupplierSkuList.push({
                        SupplierSkuId: '',
                        SupplierSkuName: '',
                        MappingCount: 1
                    });
                }

                skuList[i].SupplierSkuList.push({
                    SupplierSkuId: '',
                    SupplierSkuName: '',
                    MappingCount: 1
                });
            }
        }
        selectProduct.Skus = skuList;

        this.setState({ selectProduct: selectProduct })
    }

    //规格型号 删除规格
    deleteSupplierProductSku = (e, skuId, index) => {
        var selectProduct = this.state.selectProduct;
        var skuList = selectProduct.Skus;

        for (let i = 0; i < skuList.length; i++) {
            if (skuList[i].SkuId == skuId) {
                skuList[i].SupplierSkuList.splice(index, 1);
            }
        }

        selectProduct.Skus = skuList;
        this.setState({ selectProduct: selectProduct })
    }

    //打开同步弹窗
    openSyncProductModal=()=>{
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);

        this.setState({ isSyncProductModal: true ,daterangepickerValue: start},()=>{
            //this.daterangepicker.togglePickerVisible();
        });
       
    }

    //同步商品方法
    syncProductClick=()=> {
        var shopByLists = [this.state.selectShopId];
        const {isSync,daterangepickerValue} = this.state;
        if(isSync)
        {
            // isSync true自动同步
            var data = { 
                ShopIdList: shopByLists
             }
            this.setState({ sysncStatusTaskProgress: 0,isSyncProductModal: false, });
            var that = this;
            requests({
                url: "/Product/SyncProduct",
                data: data,
                success: function (res) {
                    if (res.Success) {
                        setTimeout(() => {
                            that.changeSyncProccess();
                        }, 1000)
                    } else {
                        messageShow("同步错误：" + res.Message, "error");
                        that.setState({ sysncStatusTaskProgress: 100 });
                    }
                },
            });
        }else{
            messageShow("已提交后台执行，请在同步完成后，再刷新页面查看数据！", "success");
            let _daterangepickerValue = daterangepickerValue;
            if(daterangepickerValue) {
                let _date = dayjs(daterangepickerValue);
                _daterangepickerValue =`${_date.$y}-${_date.$M + 1}-${_date.$D}`
            }
            // isSync true自动同步
            var data = { 
                ShopId: this.state.selectShopId,
                // 商品状态
                ProductStatus: $("#goodStatusId").val(),
                ProductIds: $("#goodsId").val(),//商品Id
                // 日期区间
                StartTime: _daterangepickerValue, 
            }
            this.setState({ sysncStatusTaskProgress: 0,isSyncProductModal: false,syncConditionStatus:false });
            var that = this;
            requests({
                url: "/Product/AssignProductSyncByShop",
                data: data,
                success: function (res) {
                    if (res.Success) {
                        setTimeout(() => {
                            that.changeSyncProccess();
                        }, 2000)
                    } else {
                        messageShow("同步错误：" + res.Message, "error");
                        that.setState({ sysncStatusTaskProgress: 100 });
                    }
                },
            });
        }

        
        

    }
    //更新同步进度
    changeSyncProccess() {
        var that = this;
        var data = {
            ShopIds: [this.state.selectShopId],
            SyncType: 2,
            PlatformType: this.state.selectplatformType
        }

        requests({
            url: "/Common/GetSyncStatusProccess",
            data: data,
            success: function (res) {
                if (res.Success) {
                    if (res.Data == 100) {
                        that.setState({ sysncStatusTaskProgress: res.Data, isSync: false });

                        that.shopLastSyncTime();
                    } else {
                        that.setState({ sysncStatusTaskProgress: res.Data });
                        setTimeout(() => { that.changeSyncProccess(); }, 1000);
                    }
                } else {
                    // messageShow("同步错误：" + res.Message,"error");
                    // that.setState({ sysncStatusTaskProgress: 0 });
                }
            },
        });

    }

    sureRelevance = () => {
        this.sureRelevanceRequest(false);
    }
    //获取店铺最后同步时间
    shopLastSyncTime() {
        var that = this;
        var data = {
            ShopIds: [this.state.selectShopId],
            SyncType: 2,
            PlatformType: this.state.selectplatformType
        }

        requests({
            url: "/Common/GetLastSyncTime",
            data: data,
            success: function (res) {
                if (res.Success) {
                    that.setState({ lastSyncTimeByShop: res.Data });
                } else {
                    // messageShow("同步错误：" + res.Message,"error");
                    // that.setState({ sysncStatusTaskProgress: 0 });
                }
            },
        });

    }
    //显示关联弹框
    relevanceProducShowButt = (item) => {
        this.closeRelevanceProduct();//显示前。先清除下数据

        //改成通过接口获取
        var productId = item.PlatformId;
        var shopId = item.ShopId;

        var data = {
            ShopId: shopId,
            ProductId: productId
        };
        this.setState({ isLoading: true, loadingTitle: '获取信息中...' });
        var that = this;
        requests({
            url: "/Product/LoadProductSkuMapping",
            data: data,
            success: function (res) {
                //关闭动画
                that.setState({ isLoading: false });

                if (res.Success) {
                    var skuList = res.Data.AlibabaProductSku;
                    var product = res.Data.ProductFx;

                    var supplierProductSkuList = [];
                    if (skuList.length > 0) {
                        for (let i = 0; i < skuList.length; i++) {
                            supplierProductSkuList.push({
                                label: skuList[i].Color + skuList[i].Size,
                                value: skuList[i].SkuId
                            });
                        }
                    }
                    product.Skus.sort(s => s.SystemStatus);
                    var priceArr = [];
                    for (let i = 0; i < product.Skus.length; i++) {
                        priceArr.push(product.Skus[i].SalePrice);
                        //如果发现后台返回值的mappingcount为0，改为1
                        if (product.Skus[i].SupplierSkuList != null) {
                            for (let n = 0; n < product.Skus[i].SupplierSkuList.length; n++) {
                                if (product.Skus[i].SupplierSkuList[n].MappingCount == null || product.Skus[i].SupplierSkuList[n].MappingCount == 0) {
                                    product.Skus[i].SupplierSkuList[n].MappingCount = 1;
                                }
                            }
                        } else if (product.Skus[i].SupplierSkuId != null && product.Skus[i].SupplierSkuId > 0) {
                            product.Skus[i].SupplierSkuList = [];
                            product.Skus[i].SupplierSkuList.push({
                                SupplierSkuId: product.Skus[i].SupplierSkuId,
                                SupplierSkuName: product.Skus[i].SupplierSkuName,
                                MappingCount: 1
                            });
                        }
                    }
                    priceArr.sort();
                    product.PriceArr = priceArr;

                    that.setState({
                        selectProduct: product,
                        selectSupplierLoginId: res.Data.SupplierLoginId,
                        selectSupplierProductId: res.Data.SupplierProductId,
                        supplierProductSkuList: supplierProductSkuList,
                        selectSourcePlatform: res.Data.SourcePlatform
                    }, () => {
                        $(".RelevanceProduct .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
                            if ($(item).val() != "") {
                                $(item).addClass("active")
                            }
                        })
                    });

                    that.setState({ isShowRelevanceProduct: true });
                } else {
                    messageShow("关联：" + res.Message, 'error');
                }
            },
        });
    }
    closeRelevanceProduct = () => {
        this.setState({
            isShowRelevanceProduct: false,//显示关联商品页面
            isShowRelevanceProductOld: false,
            selectProduct: null,
            selectSupplierLoginId: '',
            selectSupplierProductId: '',
            selectSourcePlatform: '',
            supplierProductSkuList: '',
            selectPlatformTypeRelevance: '',
        })
    }
    gotoPlatformGoods(platformId) {
        var url = "https://s.kwaixiaodian.com/zone/goods/release/edit/ordinary?itemId=" + platformId;

        window.open(url, "_blank");
    }
    //确定关联 弹框
    relevanceShowDailog = (item, isReplace) => {

        if (isReplace == false && item.SupplierProductId != "" && item.SupplierProductId != null && item.SupplierProductId != undefined) {
            this.setState({ relevanceDialogVisible: true, confirmRelevanceProduct: item })
            return false;
        }

        if (!item)
            item = this.state.confirmRelevanceProduct;

        let productItem = item;
        let that = this;
        let productCode = productItem.ProductCode;
        var productList = this.state.productList;
        var selectProduct = null;

        for (var i = 0; i < productList.length; i++) {
            if (productList[i].ProductCode == productCode) {
                var skuList = productList[i].Skus;
                if (skuList == null || skuList == undefined)
                    skuList = [];

                //重置下。
                for (let j = 0; j < skuList.length; j++) {
                    skuList[j].SupplierSkuId = '';
                    skuList[j].SupplierSkuName = '';
                }
                productList[i].Skus = skuList;

                selectProduct = productList[i];
            }
        }

        this.setState({ productList: productList, selectProduct: selectProduct });

        var supplierProduct = this.state.supplierProduct;
        if (supplierProduct == null || supplierProduct == undefined) {
            messageShow('供应商商品未找到', "warning");
            return false;
        }


        setTimeout(() => {
            // app.DialogShow({
            //     title: "规格映射",
            //     footer: true,
            //     onOk: () => that.sureRelevanceRequest(),  //保存规格映射
            //     footerActions: ['ok', 'cancel'],
            //     content: that.relevanceShowDailogHtml(productItem)
            // })

            this.setState({
                isRelevanceModal: true,
                relevanceProductItem: productItem
            }, () => {
                $(".dailogSkuMapWrap .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
                    if ($(item).val() != "") {
                        $(item).addClass("active")
                    }
                })
            })

        }, 100);



    }
    relevanceShowDailogHtml = (item) => {

        // let PlatformTypeName = item.PlatformType == "KuaiShou" ? "快手" : item.PlatformType == "TouTiao" ? "抖音" : item.PlatformType == "Pinduoduo" ? "拼多多" : item.PlatformType == "Taobao" ? "淘宝" : "";
        let PlatformTypeName = getPlatformName(item.PlatformType);
        let imgSrc = item.ImageUrl ? item.ImageUrl : "";
        let productName = item.Subject;
        let skus = [];
        if (item.Skus && item.Skus.length > 0) {
            skus = item.Skus;
        }
        let supplierProductSkuList = this.state.supplierProductSkuList;

        return (
            <div className="dailogSkuMapWrap" style={{ paddingBottom: "60px" }}>
                <div className="dailogSkuMapWrap-up">
                    <div className="dailogSkuMapWrap-up-title">已关联的{PlatformTypeName}商品信息</div>
                    <div className="dailogSkuMapWrap-up-main">
                        <div className="productShow table-product">
                            <div className="productShow-imgWrap">
                                <img src={imgSrc} alt="" />
                            </div>
                            <ul>
                                <li title="商品标题">{productName}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="dailogSkuMapWrap-down">
                    {
                        this.state.environmentNumber == 5 ?
                            <table className="table-style01">
                                <thead>
                                    <tr>
                                        <th style={{ width: "25%" }}>{PlatformTypeName}宝贝信息</th>
                                        <th style={{ width: "60%" }}>产品信息</th>
                                        <th style={{ width: "15%" }}>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        skus.length == 0 ?
                                            <tr><td colSpan="2">没有规格信息</td></tr> :
                                            skus.map((item) =>
                                                <tr>
                                                    <td>{item.AttributeValue1}{item.AttributeValue2}</td>
                                                    {
                                                        item.SupplierSkuList != null && item.SupplierSkuList.length > 0 ?
                                                            <td>
                                                                {
                                                                    item.SupplierSkuList.map((supItem, index) =>
                                                                        <div className='SupplierSkuList-item'>
                                                                            <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}>
                                                                                <option value="" style={{ color: "#999999" }}>请选择</option>:
                                                                                {
                                                                                    this.state.supplierProductSkuList.map((item02, index02) =>
                                                                                        supItem.SupplierSkuId == item02.value ?
                                                                                            <option value={item02.value} index={index02} selected>{item02.label}</option> :
                                                                                            <option value={item02.value} index={index02}>{item02.label}</option>
                                                                                    )
                                                                                }
                                                                            </select>
                                                                            <input type='number' className='SupplierSkuList-item-input' value={supItem.MappingCount} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}></input>
                                                                            {
                                                                                item.SupplierSkuList.length > 1 ?
                                                                                    <span className='dangerColor' onClick={(e) => this.deleteSupplierProductSku(e, item.SkuId, index)}>删除</span> :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    )
                                                                }
                                                            </td> :
                                                            <td>
                                                                <div className='SupplierSkuList-item'>
                                                                    <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}>
                                                                        <option value="" style={{ color: "#999999" }}>请选择</option>:
                                                                        {
                                                                            this.state.supplierProductSkuList.map((item02, index) =>
                                                                                item.SupplierSkuId == item02.value ?
                                                                                    <option value={item02.value} index={index} selected>{item02.label}</option> :
                                                                                    <option value={item02.value} index={index}>{item02.label}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                    <input type='number' className='SupplierSkuList-item-input' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}></input>
                                                                </div>
                                                            </td>
                                                    }
                                                    <td><span className='smaDefBtn' onClick={(e) => this.addSupplierProductSku(e, item.SkuId)}>添加规格</span></td>
                                                </tr>
                                            )
                                    }
                                </tbody>
                            </table>
                            :
                            <table className="table-style01">
                                <thead>
                                    <tr>
                                        <th>{PlatformTypeName}宝贝信息</th>
                                        <th>产品信息</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        skus.length == 0 ?
                                            <tr><td colSpan="2">没有规格信息</td></tr> :
                                            skus.map((item) =>
                                                <tr>
                                                    <td>{item.AttributeValue1}{item.AttributeValue2}</td>
                                                    <td>
                                                        <select name="" id="" onChange={(e) => this.selectSupplierProduct(e, item.SkuId)}>
                                                            <option value="">请选择</option>:

                                                            {
                                                                this.stats.supplierProductSkuList.map((item02, index) =>
                                                                    item.SkuId == item02.value ?
                                                                        <option value={item02.value} index={index} selected>{item02.label}</option> :
                                                                        <option value={item02.value} index={index}>{item02.label}</option>
                                                                )
                                                            }
                                                        </select>
                                                    </td>
                                                </tr>
                                            )
                                    }
                                </tbody>
                            </table>
                    }
                </div>
            </div>
        )
    }


    changeSelect = (name, value) => {
        this.setState({
            [name]: value
        })
    }
    //确定关联货源  子传父
    sureChangeProductsModule = (option) => {
        let selectProduct = option.Relations[0];
        var productList = this.state.productList;
        for (let i = 0; i < productList.length; i++) {
            if (productList[i].PlatformId == selectProduct.ProductId) {
                productList[i].SupplierProductId = selectProduct.SupplierProductId;
                productList[i].SourcePlatform = selectProduct.SourcePlatform;
                productList[i].RelationCnt = 1;
                break;
            }
        }
        this.setState({ productList: productList, isChangeProductsModule: false });
    }
    //关闭关联货源  子传父
    closeChangeProductsModule = () => {
        this.setState({
            isChangeProductsModule: false
        })
    }
    //确定关联货源  子传父
    sureChangeProductByAlibaba = (option) => {
        this.setState({isChangeProductsModuleByAlibaba:false});
        this.setState({ current: 1 }, () => {
            this.loadProductList();
        })
    }
    //关闭关联货源  子传父
    closeChangeProductByAlibaba=()=>{
    this.setState({
            isChangeProductsModuleByAlibaba: false
        })
    }

    onChangeForm(name, value) {
        this.setState({ [name]: value })
    }
    showSkuMapping(product) {
        this.setState({
            skuMappingsModuleDailog: true,
            skuMappingSelectProduct: product,
        })
    }
    closeSkuMappingsModule = () => {
        this.setState({
            skuMappingsModuleDailog: false,
            skuMappingSelectProduct: null,
        })
    }

    showRelationProduct = async (shopId, productId) => {
        const data = {
            ShopId: shopId,
            ProductId: productId,
        }
        this.setState({ isLoading: true })
        const res = await LoadProductSkuMappingV2Request(data);
        this.setState({ isLoading: false })
        if (!res.Success) {
            messageShow(res.Message, 'error');
            return;
        }
        const showSupplierProducts = res.Data.SupplierProducts || [];
        this.state.showSupplierProducts = showSupplierProducts;
        this.setState({ showRelationProduct: true })
    }
    closeRelationProduct = () => {
        this.setState({ showRelationProduct: false })
    }
   
    onStepClick () {
        const {guideStep,guideData} = this.state;
        let _guideStep =  this.state.guideStep+1; 
        this.setState({
            guideStep: _guideStep,
            isShowGuide: _guideStep > guideData.length -1 ? false : true 
        })

        if(_guideStep > guideData.length -1){
           this.setProrUserByProductMask();
        }
    }

    onInputGoodsId (value) {
        const {syncConditionStatus} = this.state;
        let flag = value ? true : false;
        if (flag != syncConditionStatus) {
            this.setState({
                syncConditionStatus:value ? true : false
            })
        } 
        
    }

     


    render() {
        return (
            <div className='wrap'>
                <HeaderMenu />
                <main>
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeNav} defaultActive={"/shopProduct"} />
                    </div>
                    <div className="wrap-right">
                        <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav}
                            from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' : null}
                            alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()} />
                        <div className='searchWrap mywrap'>
                            <div className="zk-search">
                                <div className="zk-search-wrap">
                                    <label>
                                        <select id="productSaleId">
                                            <option value="">是否代销</option>
                                            <option value="sale">代销中</option>
                                            <option value="nosale">未代销</option>
                                            {/* {
                                                this.state.fromShopProductManagerMenu ?
                                                    <option value="nosale" selected>未代销</option> : <option value="nosale">未代销</option>
                                            } */}
                                        </select>
                                    </label>
                                    <label>
                                        <select id="productStatusId">
                                            <option value="">商品销售状态</option>
                                            <option value="published" selected>在售</option>
                                            <option value="nopublished">下架</option>
                                        </select>
                                    </label>
                                    {/* <label>
                                        <input type="text" id="productTitle" placeholder="请输入商品关键字" />
                                    </label> */}
                                    <label>
                                        <Select onChange={this.changeSelect.bind(this, "searchType")} value={this.state.searchType} clearable={true} style={{ marginRight: "10px" }}	>
                                            <Select.Option key="ProductID" label="商品ID" value="ProductID" />
                                            <Select.Option key="ProductSubject" label="商品标题" value="ProductSubject" />
                                        </Select>
                                        <input style={{ marginTop: 0 }} type="text" id="productTitle" placeholder="输入值" />
                                    </label>
                                    <Button type="primary" onClick={() => this.queryButton(true)}>查询</Button>

                                </div>



                                {
                                    this.state.isShowWarn == false ?
                                        <div className='zk-search-wrap-right'>

                                            {/* <Progress type="circle" width="45" percentage={this.state.sysncStatusTaskProgress} /> */}
                                            {
                                                this.state.isTip ?
                                                    <div className='tip-box'>
                                                        若您发现软件商品数据与店铺后台不一致，请及时同步商品以保证商品一致性
                                                        <i className='iconfont icon-chuyidong' onClick={() => this.setState({ isTip: false })}></i>
                                                    </div>
                                                    : null
                                            }

                                            <div className='zk-search-wrap-right-box'>
                                                {
                                                    this.state.sysncStatusTaskProgress == 100 || this.state.sysncStatusTaskProgress == "100"
                                                        ? this.state.isSync ?
                                                            <Button type="primary" size='large' onClick={() => this.syncProductClick()}>
                                                                {/* <i className='iconfont icon-tongbu'></i> */}
                                                                同步商品
                                                            </Button>
                                                            : <Button type="primary" size='large' onClick={() => this.openSyncProductModal()}>
                                                                {/* <i className='iconfont icon-tongbu'></i> */}
                                                                同步商品
                                                            </Button>
                                                        : <Button type="primary" size='large' loading={true} disabled>同步中</Button>
                                                }
                                                <span style={{ marginLeft: "10px", marginTop: "4px",fontSize: "10px" }}>上次同步时间:{this.state.lastSyncTimeByShop}</span>
                                            </div>

                                        </div>
                                        : null
                                }

                            </div>

                        </div>

                        <div className='mywrap'>

                            <table className='table-style01'>
                                <thead>
                                    <tr>
                                        <th style={{ minWidth: "180px" }}>店铺</th>
                                        <th style={{ minWidth: "300px" }}>商品信息</th>
                                        <th style={{ minWidth: "100px" }}>在售状态</th>
                                        <th style={{ minWidth: "100px" }}>价格</th>
                                        {
                                            this.state.isShowDiagnosis == true ?
                                                <th style={{ minWidth: "100px" }}>
                                                    <div className='zlCountWrap'>
                                                        <span>商品质量分<i className='iconfont icon-tips'></i></span>
                                                        <div className='dailog-sd' style={{ width: "360px", position: "fixed", left: "unset", marginTop: "-90px", top: "unset" }}>系统根据商品信息的完整度和合规度测算出的分值，优化商品信息可提升质量分，有助于商品获得更多曝光和转化。品牌和属性请避免填写“其他”，否则不计入质量分</div>
                                                    </div>
                                                </th> : null
                                        }
                                        {
                                            this.state.isShowDiagnosis == true ? <th style={{ minWidth: "100px" }}>建议</th> : null
                                        }

                                        <th style={{ minWidth: "150px" }}>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.isNoProductList ?
                                            <tr>
                                                <td className="noneData" colSpan="20">
                                                    <div className="noneData-wrap">
                                                        <i className="iconfont icon-wushuju"></i>
                                                        <span className="noneData-title">暂无数据！</span>
                                                    </div>
                                                </td>
                                            </tr> : null
                                    }

                                    {this.state.productList.map((item) =>
                                        <tr>
                                            <td>
                                                <div className="newPlatformIconWrap">
                                                    <PlatformName platformType={item.PlatformType} isHidePatformName={true} />
                                                    <span style={{ marginLeft: "5px" }}>{this.state.selectShopName}</span>
                                                </div>
                                                {/* <div className="newPlatformIconWrap"><i className={"newPlatformIcon tinyIcon " + item.PlatformType} style={{ marginRight: "5px" }}></i><span>{this.state.selectShopName}</span></div> */}
                                            </td>
                                            <td>
                                                <div className="productShow table-product">
                                                    <div className="productShow-imgWrap">
                                                        <img src={item.ImageUrl} alt="" />

                                                        {
                                                            item.SupplierProductId == '' ?
                                                                <span className="product-status" style={{ backgroundColor: "#3aadff" }}>未代销</span>
                                                                : <span className="product-status" style={{ backgroundColor: "#f7941f" }}>已代销</span>
                                                        }
                                                    </div>
                                                    <ul>
                                                        <li title="商品标题">{item.Subject}</li>
                                                        <li>商品Id：{item.PlatformId}</li>
                                                        {
                                                            item.SupplierProductId ?
                                                                <li>
                                                                    <span className='hover defColor' onClick={() => this.showRelationProduct(item.ShopId, item.PlatformId)}>关联商品数量：{item.RelationCnt}个</span>
                                                                </li> : null
                                                        }

                                                    </ul>
                                                </div>
                                            </td>
                                            <td>
                                                {
                                                    item.Status == "published" ?
                                                        <div><i className="dot-ZT" style={{ backgroundColor: "#027cff" }}></i><span>在售</span></div> :
                                                        <div><i className="dot-ZT" style={{ backgroundColor: "#ff511c" }}></i><span>下架</span></div>
                                                }

                                            </td>
                                            <td>
                                                {
                                                    <div><span>￥{item.minPrice}</span></div>
                                                }
                                            </td>
                                            {
                                                this.state.isShowDiagnosis == true ?
                                                    <td>
                                                        {
                                                            item.isLoadItemDiagnosis == true ?
                                                                <div>
                                                                    <span style={{ color: "#f7941f" }}>加载中<i className="dot-ani"></i></span>
                                                                </div>
                                                                :
                                                                <div className='diagnosisWrap'>
                                                                    <div className='diagnosisWrap-up'>
                                                                        <span className='diagnosisWrap-up-num' style={{ color: item.DiagnosisValue < 60 ? "#ff511c" : item.DiagnosisValue < 90 ? "#f7941f" : item.DiagnosisValue < 100 ? "#5584ff" : "#5584ff" }}>{item.DiagnosisValue}</span>
                                                                        <span className='diagnosisWrap-up-content'>{item.SuggestionCount}项待优化</span>

                                                                        {/* 鼠标悬浮的内容 */}
                                                                        <div className='dailog-sd'>
                                                                            <div className='diagnosisWrap-title'>
                                                                                <div className='diagnosisWrap-title-left'>
                                                                                    <span style={{ color: "#04385d" }}>商品质量分</span>
                                                                                    <div className="semicircleProOut">
                                                                                        <div className={item.DiagnosisValue < 60 ? "semicirclePro rotate1" : item.DiagnosisValue < 90 ? "semicirclePro rotate2" : item.DiagnosisValue < 100 ? "semicirclePro rotate3" : "rotate"} style={{ transform: 'rotate(' + item.circleProValue + 'deg)' }}></div>
                                                                                        <div className="semicircleProtext">{item.DiagnosisValue}</div>
                                                                                    </div>
                                                                                </div>
                                                                                <span className='norDefBtn' onClick={() => this.gotoPlatformGoods(item.PlatformId)}>去优化</span>
                                                                            </div>
                                                                            <div className='diagnosisWrap-main'>
                                                                                <div className='diagnosisWrap-main-text'><span className='diagnosisWrap-main-num'>{item.SuggestionCount}</span>项待优化</div>
                                                                                <div className='diagnosisWrap-content'>
                                                                                    {
                                                                                        item.ItemDiagnosisList.map((diagnosisList) =>
                                                                                            <div className='diagnosisWrap-content-item'>
                                                                                                <span style={{ marginRight: "3px" }}>●</span>
                                                                                                <span>{diagnosisList.Title}</span>
                                                                                                <span>:{diagnosisList.Content}</span>
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        }

                                                    </td> : null
                                            }


                                            {
                                                this.state.isShowDiagnosis == true ?
                                                    <td>
                                                        <div className='suggestWrap'>
                                                            {
                                                                item.SuggestList.map((itemsugg) =>
                                                                    <span>{itemsugg}</span>
                                                                )
                                                            }
                                                        </div>
                                                    </td> : null
                                            }

                                            <td>
                                                {
                                                    this.state.offerId != "" ?
                                                        <span className="defColor hover" onClick={() => this.relevanceShowDailog(item, false)}>确定关联</span>
                                                        : null
                                                }
                                                {
                                                    this.state.fromShopProductManagerMenu == true && item.RelationCnt <= 1 ?
                                                        item.SupplierProductId ?
                                                            <span className="defColor hover" style={{ marginRight: "15px" }} onClick={() => this.replateSupplierProduct(item)}>更换货源</span> :
                                                            <span className="defColor hover" style={{ marginRight: "15px" }} onClick={() => this.addSupplierProduct(item, 0)}>关联货源</span>
                                                        : null
                                                }


                                                {/*
                                                {
                                                    this.state.isShowDiagnosis == true ?
                                                        <span className="defColor hover" onClick={() => this.gotoPlatformGoods(item.PlatformId)}>编辑商品</span>
                                                        : null
                                                } */}


                                                {/* {
                                                    item.SupplierProductId == '' ?
                                                    <span className="defColor hover" style={{ marginRight: "15px" }} onClick={() => this.replateSupplierProduct02(item,1)}>找同款</span>
                                                    : <span className="defColor hover" style={{ marginRight: "15px" }} onClick={() => this.relevanceProducShowButt(item)}>规格映射</span>
                                                } */}
                                                {
                                                    item.SupplierProductId == '' ?
                                                    <MyPopover
                                            trigger="click" content={
                                                <ul className='myPopover-contetnt'>
                                                            <li className='myPopover-contetnt-item'>
                                                                <label>
                                                                    <span className="hover" style={{ marginRight: "15px" }} onClick={() => this.changeProductConfirmByAlibaba(item)}>1688低价找货源</span>
                                                                </label>
                                                            </li>                                           
                                                            <li className='myPopover-contetnt-item'>
                                                                <label>
                                                                    <span className="hover" style={{ marginRight: "15px" }} onClick={() => this.addSupplierProduct(item, 1)}>店管家找同款</span>
                                                                </label>
                                                            </li>
                                                          
                                                       
                                                </ul>
                                            }
                                            >
                                                {
                                                        <span className="defColor hover" style={{ marginRight: "15px" }} >
                                                            找同款
                                                            <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                        </span>
                                                }
                                        </MyPopover>
                                                       
                                                        : <span className="defColor hover" style={{ marginRight: "15px" }} onClick={() => this.showSkuMapping(item)}>匹配规格</span>
                                                }

                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <div className='paginationwrap'>
                                <Pagination onCurrentChange={this.changeCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.total} pageSize={this.state.pageSize} currentPage={this.state.current} pageSizes={[10, 30, 50]} />
                            </div>
                        </div>
                    </div>
                </main>

                <ChangeProductsModuleV2
                    selectProductId={this.state.selectedShopProduct ? this.state.selectedShopProduct.PlatformId : ""}
                    selectedShopProductImgSrc={this.state.selectedShopProduct ? this.state.selectedShopProduct.ImageUrl : ""}
                    title={this.state.changeSupplierProduct ? "更换货源" : "关联货源"}
                    changeSupplierProduct={this.state.changeSupplierProduct}
                    showModal={this.state.isChangeProductsModule}
                    activeSearchNavId={this.state.changeSearchNavsType}

                    closeChangeProductsModule={this.closeChangeProductsModule}
                    sureRelevanceRequest={this.sureChangeProductsModule}
                    sureMapBtnName="确认关联"
                />
                <ChangeProductByAlibaba
                   selectProductId={this.state.selectedShopProduct?this.state.selectedShopProduct.PlatformId:""}
                   selectedShopProductImgSrc={this.state.selectedShopProduct?this.state.selectedShopProduct.ImageUrl:""}
                   changeSupplierProduct={this.state.changeSupplierProduct}//需要替换的货源
                   showModal={this.state.isChangeProductsModuleByAlibaba}
                   title="1688低价找货源"
                   sureRelevanceRequest={this.sureChangeProductByAlibaba}
                   closeChangeProductByAlibaba={this.closeChangeProductByAlibaba}
                />



                {/* 同步商品弹窗 */}
                <ShowModal titleName={"同步商品"} showModal={this.state.isSyncProductModal} hideBtn={true}>
                    <div className="showModalWrap-box-commonContent" style={{ padding: "20px", fontSize: "16px" }}>
                        {/* <div className="showModalWrap-box-commonContent-item flex">
                            <label >请选择店铺：</label>
                            {
                                this.state.shopList.length ? <Select onChange={this.changeSelect.bind(this, "productsId")} value={this.state.productsId} clearable={true}>
                                    {
                                        this.state.shopList.map(el => {
                                            return (
                                                <Select.Option key={el.value} label={el.name} value={el.value}>
                                                    <div className='showModalWrap-box-commonContent-item-option flex'>
                                                        <img src="https://img0.baidu.com/it/u=4265750103,992464310&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500" />
                                                        <span>{el.name}</span>
                                                    </div>
                                                </Select.Option>
                                            )
                                        })
                                    }
                                </Select> : null
                            }

                        </div> */}
                        <div className="showModalWrap-box-commonContent-item flex">
                            <label>创建时间：</label>
                            <DatePicker
                            value={this.state.daterangepickerValue}
                            placeholder="选择日期范围"
                            isShowTime={true}
                            ref={e=>this.daterangepicker = e}
                            format="yyyy-MM-dd HH:mm:ss"
                            isDisabled={this.state.syncConditionStatus}
                            onChange={date=>{
                                // console.log('DateRangePicker1 changed: ', date)
                                this.setState({daterangepickerValue: date})
                            }}
                            shortcuts={[{
                                text: '最近一周',
                                onClick: ()=> {
                                  const start = new Date();
                                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    
                                  this.setState({daterangepickerValue: start})
                                  this.daterangepicker.togglePickerVisible()
                                }
                              }, {
                                text: '最近一个月',
                                onClick: ()=> {
                                  const start = new Date();
                                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    
                                  this.setState({daterangepickerValue: start})
                                  this.daterangepicker.togglePickerVisible()
                                }
                              }, {
                                text: '最近三个月',
                                onClick: ()=> {
                                  const start = new Date();
                                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                  this.setState({daterangepickerValue: start})
                                  this.daterangepicker.togglePickerVisible()
                                }
                            }, {
                                text: '最近六个月',
                                onClick: ()=> {
                                  const start = new Date();
                                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                                  this.setState({daterangepickerValue: start})
                                  this.daterangepicker.togglePickerVisible()
                                }
                            }]}
                            />
                        </div>
                        <div className="showModalWrap-box-commonContent-item flex">
                            <label >商品状态：</label>
                            <select id="goodStatusId" disabled={this.state.syncConditionStatus}>
                                <option value="">商品销售状态</option>
                                <option value="published" selected>在售</option>
                                <option value="nopublished">下架</option>
                            </select>
                        </div>
                        <div className="showModalWrap-box-commonContent-item flex">
                            <label>商品ID：</label>
                            <input type="text" id='goodsId' placeholder='输入商品ID,多个商品ID使用(,)分割' onInput={(e) => this.onInputGoodsId(e.target.value)}/>
                            
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span onClick={() => this.syncProductClick()} className="showModalWrap-box-footer-btn">同步</span>
                        <span onClick={() => this.setState({ isSyncProductModal: false,syncConditionStatus:false })} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>

                {/** 确认关联 */}
                <Dialog title="确认" size="tiny" visible={this.state.relevanceDialogVisible} onCancel={() => this.setState({ relevanceDialogVisible: false })} lockScroll={false} >
                    <Dialog.Body>
                        <span>该商品已经关联过货源，确认是否替换为当前货源？</span>
                    </Dialog.Body>
                    <Dialog.Footer className="dialog-footer">
                        <Button onClick={() => this.setState({ relevanceDialogVisible: false })}>取消</Button>
                        <Button type="primary" onClick={() => {
                            this.setState({ relevanceDialogVisible: false });
                            this.relevanceShowDailog(null, true);
                        }}>确定</Button>
                    </Dialog.Footer>
                </Dialog>

                <ShowModal titleName={"关联货源"} showModal={this.state.confrimChangeProduct} hideBtn={true}>
                    <div className="showModalWrap-box-commonContent" style={{ padding: "20px", fontSize: "16px" }}>
                        <div className="showModalWrap-commonContent-item">
                            <i className="iconfont icon-wenhao icofontStatus"></i>
                            <span>当前商品已经关联过货源,确认是否更换货源?</span>
                            <span style={{ paddingLeft: "44px" }}>店铺商品被下单将全部采购新货源</span>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span onClick={() => this.replateSupplierProduct02()} className="showModalWrap-box-footer-btn">确认关联</span>
                        <span onClick={() => this.closeConfrimChangeProduct()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>


                {/* 关联货源 */}
                <ShowModal skin={"changeProductsWrap"} width={this.state.changeWidth} titleName={"更换货源"} showModal={this.state.isShowChangeProduct} hideBtn={true}>
                    <div className="showModalWrap-box-commonContent changeProductsWrap-commonContent">
                        <div className="showModalWrap-commonContent-item">
                            <div className='showModalWrap-commonContent-warn changeProductsWrap-warn'>
                                <div className="confirmComom-icon">!</div>
                                <ul>
                                    <li>1、更换货源时，注意货源的起批量，避免因起批量不足导致不能正常采购。</li>
                                    <li>2、更换货源成功后，当店铺商品被买家下单时会全部采购新货源，并同步发货和物流信息；</li>
                                    <li>3、如想取消关联货源，可以到代销商品-代销中，找到商品并终止代销；</li>
                                    <li>4、对于未进行映射货源的店铺商品规格，则不能正常采购。</li>
                                    <li>5、您和供应商任意一方修改规格名/删除规格，都会导致匹配关系失效，需要重新进行匹配。</li>
                                </ul>
                            </div>
                        </div>
                        <div className={this.state.changeStatus == 'second' ? 'showModalWrap-commonContent-item showModalWrapstepWrap showModalWrapstepWrapsecond' : "showModalWrap-commonContent-item showModalWrapstepWrap"}>
                            <Steps space={200} active={this.state.changeStatus == 'first' ? 1 : this.state.changeStatus == 'second' ? 2 : ""}>
                                <Steps.Step title="步骤 1" description="添加货源链接"></Steps.Step>
                                <Steps.Step title="步骤 2" description="映射货源规格"></Steps.Step>
                            </Steps>
                            {/*                            
                            <div className="commonContent-steps">
                                <div className={this.state.changeStatus == 'first' || this.state.changeStatus == 'second' ? 'commonContent-steps-one active' : 'commonContent-steps-one'}>
                                    <span className='commonContent-steps-one-num'>1</span>
                                    <span className='commonContent-steps-one-title'>添加货源链接</span>
                                </div>
                                <div className={this.state.changeStatus == 'second' ? 'commonContent-steps-one active' : 'commonContent-steps-one'}>
                                    <span className='commonContent-steps-one-num'>2</span>
                                    <span className='commonContent-steps-one-title'>映射货源规格</span>
                                </div>
                            </div> */}
                        </div>
                        <div style={this.state.changeStatus == 'first' ? { display: 'inline' } : { display: 'none' }}>
                            <div className="showModalWrap-commonContent-item">
                                <textarea className='link-textarea' placeholder='请输入新的1688货源商品链接或淘口令' id="textareaByChangeProductId" style={{ overflow: "hidden", width: "100%", }} onInput={() => this.inputTextareaByChangeProduct()} onBlur={(e) => this.loadSupplierProductByUrl(e.target.value)}></textarea>
                            </div>
                            <div className="showModalWrap-commonContent-item showModalWrap-commonContent-loadWrap" style={this.state.isShowWarnText ? { display: 'flex' } : { display: 'none' }}>
                                <div style={this.state.isShowLoadAction ? { display: 'inline' } : { display: 'none' }}><span className='loadmore'></span></div>
                                {
                                    this.state.isShowWarnText ?
                                        <div className='noticeText'>
                                            <i className='iconfont icon-shanchu dangerColor'></i>{this.state.noticeText}</div> :
                                        <span className='noticeText02'>{this.state.noticeText}</span>
                                }

                            </div>

                            <div className="showModalWrap-commonContent-item productShow showModalWrapProductShow" style={this.state.changeProduct != null ? { display: 'flex' } : { display: 'none' }}>
                                <span className='productShow-title'>货源信息</span>
                                <div className='productShow-content'>
                                    <div className='productShow-content-img'>
                                        <img src={this.state.changeProduct != null ? this.state.changeProduct.ImageUrl : ''}></img>
                                    </div>
                                    <ul className='productShow-content-sku'>
                                        <li>{this.state.changeProduct != null ? this.state.changeProduct.Subject : ''}</li>
                                        <li className='dangerColor'>¥{this.state.changeProduct != null ? this.state.changeProduct.PriceArr[0] : ''}
                                            ~{this.state.changeProduct != null ? this.state.changeProduct.PriceArr[this.state.changeProduct.PriceArr.length - 1] : ''}</li>
                                        <li>库存：{this.state.changeProduct != null ? this.state.changeProduct.SupplyStock : ''}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div style={this.state.changeStatus == 'second' ? { display: 'inline' } : { display: 'none' }}>
                            <div className='second-SkuMapWrap-top'>
                                <div className="dailogSkuMapWrap-up">
                                    {
                                        this.state.noticeText == '' ?
                                            <div>
                                                <div className="dailogSkuMapWrap-up-title">
                                                    <span>已关联{getPlatformName(this.state.selectPlatformTypeRelevance)}的商品</span>
                                                </div>
                                                <div className="dailogSkuMapWrap-up-main">
                                                    <div class="productShow table-product">
                                                        <div className="productShow-imgWrap">
                                                            {
                                                                this.state.selectProduct != null ?
                                                                    <img src={this.state.selectProduct.ImageUrl == null || this.state.selectProduct.ImageUrl == "" ? "" : this.state.selectProduct.ImageUrl} alt="" />
                                                                    : null
                                                            }

                                                        </div>
                                                        <ul>
                                                            <li title="商品标题">{this.state.selectProduct == null ? "" : this.state.selectProduct.Subject}</li>
                                                            <li className='dangerColor'>售价：￥{this.state.selectProduct == null || this.state.selectProduct.PriceArr == null ? "" : this.state.selectProduct.PriceArr[0]}起</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div> :
                                            <div>
                                                <div className='productShowLoadmore'><span style={{ width: "30px", height: "30px" }} className='loadmore'></span>{this.state.noticeText}</div>
                                            </div>
                                    }
                                </div>
                                <div className='dailogSkuMapWrap-mid'>
                                    <span>对应货源</span>
                                    <i className='iconfont icon-fanhuidingbu'></i>
                                </div>
                                <div className="dailogSkuMapWrap-up">
                                    <div className="dailogSkuMapWrap-up-title">
                                        <span>已关联1688的商品</span>
                                    </div>
                                    <div className="dailogSkuMapWrap-up-main">
                                        <div className="productShow table-product">
                                            <div className="productShow-imgWrap">
                                                {
                                                    this.state.changeProduct != null ?
                                                        <img src={this.state.changeProduct.ImageUrl == null || this.state.changeProduct.ImageUrl == "" ? "" : this.state.changeProduct.ImageUrl} alt="" />
                                                        : null
                                                }
                                            </div>
                                            <ul>
                                                <li title="商品标题">{this.state.changeProduct == null ? "" : this.state.changeProduct.Subject}</li>
                                                <li className='dangerColor'>进货价：￥{this.state.changeProduct == null || this.state.changeProduct.PriceArr == null ? "" : this.state.changeProduct.PriceArr[0]}起</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="dailogSkuMapWrap-down">
                                <table className="table-style01">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "350px" }}>{getPlatformName(this.state.selectPlatformTypeRelevance)}规格信息</th>
                                            <th style={{ width: "410px" }}>产品信息</th>
                                            <th style={{ width: "90px" }}>操作</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.selectProduct == null || this.state.selectProduct.Skus.length == 0 ?
                                                <tr><td colSpan="2">没有规格信息</td></tr> :
                                                this.state.selectProduct.Skus.map((item, index) =>
                                                    <tr>
                                                        <td>{item.AttributeValue1}{item.AttributeValue2}</td>
                                                        {
                                                            item.SupplierSkuList != null && item.SupplierSkuList.length > 0 ?
                                                                <td>
                                                                    {
                                                                        item.SupplierSkuList.map((supItem, index) =>
                                                                            <div className='SupplierSkuList-item'>
                                                                                <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}>
                                                                                    <option value="">请选择</option>:
                                                                                    {
                                                                                        this.state.supplierProductSkuList.map((item02, index02) =>
                                                                                            supItem.SupplierSkuId == item02.value ?
                                                                                                <option value={item02.value} index={index02} selected>{item02.label}</option> :
                                                                                                <option value={item02.value} index={index02}>{item02.label}</option>
                                                                                        )
                                                                                    }
                                                                                </select>
                                                                                <input type='number' value={supItem.MappingCount} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}></input>
                                                                                {
                                                                                    item.SupplierSkuList.length > 1 ?
                                                                                        <span className='dangerColor' onClick={(e) => this.deleteSupplierProductSku(e, item.SkuId, index)}>删除</span> :
                                                                                        null
                                                                                }
                                                                            </div>
                                                                        )
                                                                    }
                                                                </td> :
                                                                <td>
                                                                    <div className='SupplierSkuList-item'>
                                                                        <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}>
                                                                            <option value="">请选择</option>:
                                                                            {
                                                                                this.state.supplierProductSkuList.map((item02, index) =>
                                                                                    item.SupplierSkuId == item02.value ?
                                                                                        <option value={item02.value} index={index} selected>{item02.label}</option> :
                                                                                        <option value={item02.value} index={index}>{item02.label}</option>
                                                                                )
                                                                            }
                                                                        </select>
                                                                        <input type='number' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}></input>
                                                                    </div>
                                                                </td>
                                                        }
                                                        <td><span className='defColor hover' onClick={(e) => this.addSupplierProductSku(e, item.SkuId)}>添加规格</span></td>
                                                    </tr>
                                                )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <div style={this.state.changeStatus == 'first' ? { display: 'flex' } : { display: 'none' }}>
                            <span style={this.state.changeProduct != null ? { cursor: "pointer", 'background-color': "#5584ff", border: '1px solid #5584ff' } :
                                { cursor: "not-allowed", 'background-color': "#ccc", border: '1px solid #ccc' }}
                                onClick={() => this.relevanceProducFromChange()} className="showModalWrap-box-footer-btn">下一步</span>
                        </div>
                        <span style={this.state.changeStatus == 'second' ? { display: 'flex', marginRight: "5px" } : { display: 'none' }} onClick={() => this.previousChangeProduct()}
                            className="showModalWrap-box-footer-btn cancleBtn">上一步</span>
                        <span style={this.state.changeStatus == 'second' ? { display: 'flex' } : { display: 'none' }} onClick={() => this.sureRelevanceRequest()}
                            className="showModalWrap-box-footer-btn">确定关联</span>
                        <span onClick={() => this.closeChangeProduct()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>

                {/* 规格映射 弹框 */}
                <ShowModal skin={"RelevanceProduct"} width={"730px"} showModal={this.state.isShowRelevanceProduct} sureDailog={() => this.sureRelevanceRequest(false)} titleName={'规格映射'} sureBtnName={"确定"} cancelDailog={this.closeRelevanceProduct} >
                    <div className="dailogSkuMapWrap">
                        <div className="dailogSkuMapWrap-up">

                            <div className="dailogSkuMapWrap-up-title">
                                <text>已关联{getPlatformName(this.state.selectPlatformTypeRelevance)}的商品</text>
                                <input type="checkbox" style={{ "margin-left": "10px", "margin-bottom": "2px" }} checked={this.state.isShowDeletedSku == true ? 'checked' : null} onClick={() => {
                                    this.onChangeForm(!this.state.isShowDeletedSku, 'isShowDeletedSku')
                                }} id='isShowDeletedSku' />
                                <span> 展示已删除的规格</span>
                            </div>
                            <div className="dailogSkuMapWrap-up-main">
                                <div class="productShow table-product">
                                    <div class="productShow-imgWrap">
                                        {
                                            this.state.selectProduct != null ?
                                                <img src={this.state.selectProduct.ImageUrl == null || this.state.selectProduct.ImageUrl == "" ? "" : this.state.selectProduct.ImageUrl} alt="" />
                                                : null
                                        }

                                    </div>
                                    <ul>
                                        <li title="商品标题">{this.state.selectProduct == null ? "" : this.state.selectProduct.Subject}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="dailogSkuMapWrap-down">
                            <table className="table-style01">
                                <thead>
                                    <tr>
                                        <th style={{ width: "25%" }}>{getPlatformName(this.state.selectPlatformTypeRelevance)}规格信息</th>
                                        <th style={{ width: "60%" }}>产品信息</th>
                                        <th style={{ width: "15%" }}>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.selectProduct == null || this.state.selectProduct.Skus.length == 0 ?
                                            <tr><td colSpan="2">没有规格信息</td></tr> :
                                            this.state.selectProduct.Skus.filter(s => this.state.isShowDeletedSku || s.SystemStatus != -1).map((item) =>
                                                <tr>
                                                    <td>{item.AttributeValue1}{item.AttributeValue2}
                                                        {
                                                            item.SystemStatus == -1 ?
                                                                <span class="errorColor">（已删除）</span> : null
                                                        }
                                                    </td>
                                                    {
                                                        item.SupplierSkuList != null && item.SupplierSkuList.length > 0 ?
                                                            <td>
                                                                {
                                                                    item.SupplierSkuList.map((supItem, index) =>
                                                                        <div className='SupplierSkuList-item'>
                                                                            <select className={supItem.SupplierSkuId == '' ? 'SupplierSkuList-item-select' : 'SupplierSkuList-item-select active'} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}>
                                                                                <option value="">请选择</option>:
                                                                                {
                                                                                    this.state.supplierProductSkuList.map((item02, index02) =>
                                                                                        supItem.SupplierSkuId == item02.value ?
                                                                                            <option value={item02.value} index={index02} selected>{item02.label}</option> :
                                                                                            <option value={item02.value} index={index02}>{item02.label}</option>
                                                                                    )
                                                                                }
                                                                            </select>
                                                                            <input type='number' className='SupplierSkuList-item-input' value={supItem.MappingCount} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}></input>
                                                                            {
                                                                                item.SupplierSkuList.length > 1 ?
                                                                                    <span className='dangerColor' onClick={(e) => this.deleteSupplierProductSku(e, item.SkuId, index)}>删除</span> :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    )
                                                                }
                                                            </td> :
                                                            <td>
                                                                <div className='SupplierSkuList-item'>
                                                                    <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}>
                                                                        <option value="">请选择</option>:
                                                                        {
                                                                            this.state.supplierProductSkuList.map((item02, index) =>
                                                                                item.SupplierSkuId == item02.value ?
                                                                                    <option value={item02.value} index={index} selected>{item02.label}</option> :
                                                                                    <option value={item02.value} index={index}>{item02.label}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                    <input type='number' className='SupplierSkuList-item-input' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}></input>
                                                                </div>
                                                            </td>
                                                    }
                                                    <td><span className='defColor hover' onClick={(e) => this.addSupplierProductSku(e, item.SkuId)}>添加规格</span></td>
                                                </tr>
                                            )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ShowModal>
                <ShowModal showModal={this.state.isRelevanceModal} width={"730px"} sureDailog={this.sureRelevance} cancelDailog={() => { this.setState({ isRelevanceModal: false }) }}>
                    {
                        this.state.isRelevanceModal ? this.relevanceShowDailogHtml(this.state.relevanceProductItem) : null
                    }
                </ShowModal>





                <ShowModal width={"730px"} showModal={this.state.showRelationProduct} titleName={'查看代销货源信息'} hideBtn={true} showLeftTopBtn={true} skin={"searchProductShow"} cancelDailog={() => { this.setState({ showRelationProduct: false }) }}>
                    <div className="dailogSkuMapWrap">
                        <div className='tarTxt tarTxt07 warnTar'>如想取消关联货源，可以到代销商品中，找到商品对应的货源删除或者终止代销。</div>
                        <div className="dailogSkuMapWrap-down">
                            <table className="table-style01">
                                <thead>
                                    <tr>
                                        <th style={{ width: "10%" }}></th>
                                        <th style={{ width: "75%" }}>货源商品信息</th>
                                        {/* <th style={{ width: "15%",textAlign: 'center'}}>状态</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.showSupplierProducts && this.state.showSupplierProducts.length > 0 ?
                                            this.state.showSupplierProducts.map((supplierProduct, index) =>
                                                <tr>
                                                    <td style={{ textAlign: 'center', color: '#333' }}>货源{index + 1}</td>
                                                    <td>
                                                        <div className="productShow table-product">
                                                            <div className="productShow-imgWrap">
                                                                <img src={supplierProduct.PicURI} alt="" />
                                                            </div>
                                                            <ul className='productShow-titles'>
                                                                <li title="商品标题" className='hover' >
                                                                    <a className='dColor' onClick={() => { huoyuanLink(supplierProduct) }}>{supplierProduct.Subject}
                                                                    {/* <i className='paTag'>
                                                                        {supplierProduct.SourcePlatform == 'TaoteZhuKe' ? '淘特' :
                                                                        supplierProduct.IsJxhyOffer == true ? '1688精选' : '1688'}
                                                                    </i> */}
                                                                    {supplierProduct.PickupAssr ? <span className='productShow-content-sku-tag' style={{alignItems: 'center'}}>{supplierProduct.PickupAssr}h晚揽必赔</span>:null}
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <span>供应商旺旺：</span>
                                                                    <span>{supplierProduct.SupplierLoginId}</span>
                                                                    <a href=""><i class="iconfont icon-wangwang"></i></a>
                                                                </li>
                                                                <li className='priceSow'>
                                                                    {/* <span>库存:15425</span>
                                                                <span>价格:￥15425</span>                                                    */}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                    {/* <td className='td-stauts'>
                                                    <span className='tarTxt tarTxt01'>在售</span>
                                                </td> */}
                                                </tr>
                                            ) : null
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ShowModal>


                <SkuMappingsModule
                    showModal={this.state.skuMappingsModuleDailog}
                    shopId={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.ShopId}
                    productId={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.PlatformId}
                    platformType={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.PlatformType}
                    closeSkuMappingsModule={this.closeSkuMappingsModule}
                ></SkuMappingsModule>
                <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
                <NewUserGuide></NewUserGuide>
                {/* 引导蒙层 */}
                {
                    this.state.isShowGuide ? 
                        <div className='guide'>
                            <div className={'guide-content guide-content-step-'+ (this.state.guideStep+1)}>
                            <div className="step">
                                <img src={this.state.guideData[this.state.guideStep].img} alt="" />
                            </div>
                            <div className="btn-box">
                                <Button type="primary" onClick={() => this.setState({isShowGuide:false})}>跳过</Button>
                                <span className='text'>{this.state.guideStep+1}/{this.state.guideData.length}</span>
                                <Button onClick={() => this.onStepClick()}>下一步</Button>
                            </div>
                            </div>
                            {
                                    this.state.guideStep == 0 ? 
                                    <span className='guide-tips guide-tips-step-1' >第一步：跟据查询条件，找到具体的商品</span>
                                    :null
                                }
                                {
                                    this.state.guideStep == 1 ? 
                                    <span className='guide-tips guide-tips-step-2' >第二步：如未找到对应的商品，点击此处进行同步店铺商品</span>
                                    :null
                                }
                                {
                                    this.state.guideStep == 2 ? 
                                    <span className='guide-tips guide-tips-step-3' >第三步：点击"关联货源"，进行货源与店铺商品的关联绑定。只有关联货源的商品产生订单后才能正常采购下单</span>
                                    :null
                                }
                        </div>
                    : null
                }
            </div>
        );
    }
}

export default ShopProduct;



// WEBPACK FOOTER //
// ./src/pages/shopProduct/shopProduct.jsx